import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class Details extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			catname : '',
			desig : '',
			lcount : '',
			_message : '',
			alertClass :'',
			posts : [],
			design : [],
			data : [],
			id : '',
			 _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("detform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.catname && this.state.desig && this.state.lcount){
			
			PostData('leave/adddetails',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Leave Details Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("detform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('leave/deletedetail',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Leave Details Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Leave Details',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
		this.getleavecat();
		this.getdesignation();
	}
	
	getdata(){
		
		GetData('leave/getdetail').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Category **/
	getleavecat(){
		
		GetData('leave/getcategory').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/leave/editdetail/' + this.state.idd} />);

	}
	
	var items = this.state.posts;
	var desi = this.state.design;
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="detform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Leave Details</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Leave Category <span className="text-danger">*</span></Label>
							  <select name="catname" onChange={this.onChange} className="form-control" required> 
								<option value="">Select Type</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.category}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Designation <span className="text-danger">*</span></Label>
							  <select name="desig" onChange={this.onChange} className="form-control" required>
								<option value="">Select Designation</option>
								{
									desi.map(function (item) {
										return <option value={item.id }>{item.designation}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Leave Count <span className="text-danger">*</span></Label>
							  <Input type="text" name="lcount" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Designation Name</th>
							<th>Leave Type</th>
							<th>Leave Count</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.data.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.desi}</td>
								<td>{item.cat}</td>
								<td>{item.count}</td>
								<td>
									<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
			  
						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Details;


// WEBPACK FOOTER //
// ./src/leave/Details/Details.js